<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <!-- 主要内容 -->
    <el-row>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <!-- 24.5.17 轮播图 dxm -->
        <div class="swiper-container banner-swiper" v-if="bannerArr.length > 0">
          <div class="swiper-wrapper">
            <div
                class="swiper-slide"
                v-for="(item, index) in bannerArr"
                :key="index"
            >
              <img :src="$imgUrl + item.thumb" alt/>
            </div>
          </div>
        </div>
        <!-- 24.5.17 操作按钮 dxm -->
        <button-list></button-list>
        <!-- 24.5.17 最新动态 dxm-->
        <news
            v-if="articleList.length > 0"
            :articleList="articleList"
            :newArticleList="newArticleList"
        ></news>
        <!-- 24.5.17 企业展示 dxm -->
        <enterprise
            v-if="enterpriseList.length > 0"
            :enterpriseList="enterpriseList"
            @changeDetail="changeDetail"
        ></enterprise>
        <!-- 24.5.17 精彩回顾 dxm -->
        <exciting-review
            v-if="listCate.length > 0"
            :listCate="listCate"
            @changeExdetail="changeExdetail"
        ></exciting-review>
        <!-- 24.5.18 合作媒体 dxm -->
        <media-partners
            v-if="mediaLists.length > 0"
            :mediaLists="mediaLists"
            @changeDetail="changeDetail"
        ></media-partners>
      </el-col>
    </el-row>
    <!-- <el-backtop>{{ $t("home.top") }}</el-backtop> -->
    <!-- 底部 -->
    <div class="suspension_box" v-if="suspension_show">
      <div  @click="suspensionClick">
        <img v-if="langSet == 'cn'" src="../../assets/suspension_cn.png"/>
        <img v-else src="../../assets/suspension_en.png"/>
      </div>
      <img @click="cancel" class="quxiao" src="../../assets/quxiao.png"/>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import top from "../../components/top.vue";
import bottom from "../../components/bottom.vue";
import buttonList from "./components/button.vue";
import news from "./components/news.vue";
import enterprise from "./components/enterprise.vue";
import excitingReview from "./components/excitingReview.vue";
import mediaPartners from "./components/mediaPartners.vue";
import Swiper from "swiper"; // 注意引入的是Swiper
import "../../../node_modules/swiper/css/swiper.min.css"; // 注意这里的引入

import {
  getBanner,
  getCompanyLists,
  getMediaLists,
  getListCate,
  getArticle,
} from "@/api/api";

export default {
  components: {
    top,
    bottom,
    buttonList,
    news,
    enterprise,
    excitingReview,
    mediaPartners,
  },
  name: "home",
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.langSet == "cn" ? this.keydata.name_cn : this.keydata.name_en,
      meta: [
        {
          name: "description",
          content: this.keydata.description,
        },
        {
          name: "keywords",
          content: this.keydata.keywords,
        },
      ],
    };
  },
  data() {
    return {
      suspension_show:true,
      active: "",
      items: [],
      defaultIndex: 0,
      bannerArr: [], //首页轮播图数据
      enterpriseList: [], //企业展示数据
      mediaLists: [], //合作媒体数据
      listCate: [], //精彩回顾数据
      articleList: [], //最新动态
      newArticleList: [],
      keydata: {
        keywords: "",
        description: "",
      },
      langSet: "",
      swiper: null,
    };
  },
  created() {
  },
  activated() {
    let menuArr = JSON.parse(localStorage.getItem("menuArr"));
    menuArr.map((item) => {
      if (item.name_cn == "首页" || item.name_en == "Home") {
        console.log(item, "item");
        this.keydata = item;
      }
    });
  },

  mounted() {
    this.langSet = localStorage.getItem("languageSet") || "cn";
    this.setHeight();
    this.getBannerList();
    this.getCompanyLists();
    this.getMediaLists();
    this.getListCate();
    this.getArticle();

    setTimeout(() => {
      new Swiper(".banner-swiper", {
        spaceBetween: 0,
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
      });
    }, 300);
  },
  methods: {
    changeExdetail(item) {
      this.$router.push({
        name: "wonderfulMoment",
        query: {
          id: item.id,
        },
      });
    },
    changeDetail(item) {
      if (item.type == "内链") {
        this.$router.push({
          name: "innerChain",
          query: {
            id: item.id,
          },
        });
      } else if (item.type == "外链") {
        let path = window.location.protocol + "//" + item.http_url;
        window.open(path, "_blank");
      } else {
        return;
      }
    },
    // 2025年7月3日12:00:28 添加 展商报名 链接为观众报名 赵芳鑫 李晋京
    suspensionClick() {
      // https://www.bceia.cn/#/apply
          this.$router.push({
            name: 'apply',
          });
      // window.open(this.langSet == 'cn' ? 'https://t2.eainfor.com/T/w/129_509' : 'https://t2.eainfor.com/T/pe/132_508', "_blank");
    },
    cancel(){
      this.suspension_show=!this.suspension_show
    },
    // zhang 获取首页轮播图
    getBannerList() {
      let data = {
        class: "首页banner",
        lang_type: this.langSet,
      };
      getBanner(data)
          .then((res) => {
            if (res.code == 1) {
              this.bannerArr = res.data.lists;
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    // zhang 获取企业展示 默认20条
    getCompanyLists() {
      let data = {
        page_no: 1,
        page_size: 20,
      };
      getCompanyLists(data)
          .then((res) => {
            if (res.code == 1) {
              this.enterpriseList = res.data.lists;
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    // zhang 获取精彩回顾数据 默认6条
    getListCate() {
      let data = {
        page_no: 1,
        page_size: 8,
        usage_type: "photowall",
      };
      getListCate(data)
          .then((res) => {
            if (res.code == 1) {
              this.listCate = res.data.lists;
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    // zhang 获取合作媒体数据
    getMediaLists() {
      let data = {
        page_type: 0,
        // page_no:1,
        // page_size:20
      };
      getMediaLists(data)
          .then((res) => {
            if (res.code == 1) {
              this.mediaLists = res.data.lists;
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    // zhang 获取最新动态数据
    getArticle() {
      let data = {
        page_no: 1,
        page_size: 5,
        lang: this.langSet,
      };
      getArticle(data)
          .then((res) => {
            if (res.code == 1) {
              this.articleList = res.data.lists;
              if (this.articleList.length > 0) {
                this.articleList.map((item, index) => {
                  if (index !== 0) {
                    this.newArticleList.push(item);
                  }
                });
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },

    setHeight() {
      this.height = window.innerWidth * 0.7 + "px";
    },
    //跳列表页
    // toList(path) {
    //   console.log(path);
    //   this.$router.push({ path });
    // },
    // toDetail(name, id) {
    //   console.log(name, id);
    //   this.$router.push({ name, query: { id } });
    // },
  },
};
</script>

<style lang="scss" scoped>
// 轮播图样式
.banner-swiper {
  width: 100%;
  // height: 900px;
  .swiper-wrapper {
    // display: flex;
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: flex;
    flex-wrap: nowrap;
    transition-property: transform;
    box-sizing: content-box;
  }

  .swiper-slide {
    width: 100% !important;
    text-align: center;
    font-size: 18px;
    background: #fff;

    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

//移动端
@media only screen and (max-width: 767px) {
  .banner-swiper {
    height: 3.5rem;
    margin-top: 0.88rem;
  }
}
</style>
<style lang="scss">
.el-col {
  border-radius: 0;
}

.el-backtop {
  position: relative;
  right: 0 !important;
  bottom: 0 !important;
  margin: 90px auto 30px;
  width: 174px;
  height: 53px;
  border-radius: 10px;
  border: 2px solid rgba(0, 0, 0, 1);
  color: #000;
  line-height: 53px;
  text-align: center;
  font-size: 18px;
}

.suspension_box {
  position: fixed;
  z-index: 999;
  top: 50%;
  right: 30px;
  width: 220px;
  height: 120px;
  cursor: pointer;
text-align: center;
  img {
    width: 100%;
  }
  .quxiao{
width: 30px;
    bottom: 30px;
  }
}

@media only screen and (max-width: 767px) {
  .full-page-slide-wrapper {
    height: 6rem;
    margin: 0;
    padding: 0;

    .swiper-container {
      .swiper-slide {
        width: 100%;
        border-radius: 5px;
      }
    }
  }
  .el-backtop {
    margin: 0.9rem auto 0.3rem;
    width: 3.48rem;
    height: 1.06rem;
    line-height: 1.06rem;
  }
}
</style>